import React from 'react';
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import {setUiPopupState} from "../../actions/A_Popups";
import {UI_POPUP_TYPES} from "../../reducers/R_Popups";
import {onSaveReferralProgramsClick} from "./jobAssociateFabricatorPopup/jobAssociateFabricatorApi";
import {getParsedJobOrder} from "./jobPurchaseOrderPopup/jobOrderFunctions";


const JobBoardAssociateFabricatorButton = (props) => {

  const {job, onSaveReferralProgramsClick, setUiPopupState} = props;

  const assignFabricatorClick = () => {
    console.log("job", job);
    setUiPopupState({
      headerTextId: "jobBoard.associateFabricator",
      className: "",
      style: {maxWidth: "680px", maxHeight: "540px"},
      opened: true,
      type: UI_POPUP_TYPES.associateJobFabricator,
      context: {job},
      buttons: [{}, {
        className: "ui-button5 ui-button5--wide text-uppercase ui-button5--green",
        textId: "messageBox.buttons.save",
        onClick: onSaveReferralProgramsClick,
      }],
    });
  }

  const jobOrder = getParsedJobOrder(job); // jobOrderInterface

  const disabled = jobOrder && jobOrder.orderId; // can't change after that
  if (disabled) {
    return null
  }

  return (
    <button className={"job-board-appointment-date job-board-associate-fabricator-icon bg-none border-none box-shadow-none w-15 h-15 p-0" +
      " link--green link--green-hover absolute" + (disabled ? " opacity-50 link--disabled" : " link")}
            onClick={disabled ? null : assignFabricatorClick}/>
  )
};

const mapStateToProps = () => {
  // const {auth, asCustomer} = state;
  return {
    // auth,
    // asCustomer,
  };
};

const mapDispatchToProps = {
  setUiPopupState,
  onSaveReferralProgramsClick,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(JobBoardAssociateFabricatorButton)
)
